import { render, staticRenderFns } from "./UploadDocumentDialog.vue?vue&type=template&id=633709b3&scoped=true"
import script from "./UploadDocumentDialog.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633709b3",
  null
  
)

export default component.exports